<div id="sideresultsDesktop" class="sideresult">
  <mat-sidenav
    #sidenav
    [mode]="isSmallScreen ? 'over' : 'side'"
    [autoFocus]="false"
    [opened]="hasActivePrimaryContent()"
    [ngClass]="{ 'sidenav-mobile': isSmallScreen }"
    class="primary-sidenav"
  >
    <div #content class="app-sidenav-content">
      <div
        style="margin: 24px 16px"
        *ngIf="
          searchInit === false &&
          (queryStore.empty$ | async) === true &&
          legendPanelOpened === false
        "
      >
        <section class="mat-typography custom-text">
          <!-- h5 hardcoded size! 16.01.24 -->
          <h5 style="padding-top: 40px">
            <strong>{{
              'igo.integration.searchResultsTool.noResults' | translate
            }}</strong>
          </h5>
          <h6>
            <strong>{{
              'igo.integration.searchResultsTool.doSearch' | translate
            }}</strong>
          </h6>
          <p
            [innerHTML]="
              'igo.integration.searchResultsTool.examples' | translate
            "
          ></p>
        </section>
      </div>

      <div *ngIf="mapQueryClick === true">
        <app-feature-info
          [map]="map"
          [mobile]="mobile"
          [store]="queryStore"
          [mapQueryClick]="mapQueryClick"
          [searchInit]="searchInit"
          (closeQuery)="closePanelOnCloseQuery($event)"
          (sidenavClosed)="($event)"
          (pleaseCloseSidenav)="yesICloseSidenav($event)"
          [hasFeatureEmphasisOnSelection]="hasFeatureEmphasisOnSelection"
          [scenarioDateToggle]="scenarioDateToggle"
        >
        </app-feature-info>
      </div>

      <div #search *ngIf="searchInit === true">
        <app-search-results-tool
          #searchresults
          [showIcons]="true"
          placeholder="false"
          [mapQueryClick]="mapQueryClick"
          [searchInit]="searchInit"
          (resultFocus)="onResultFocus($event)"
          (resultSelect)="onResultFocus($event)"
          (moreResults)="onSearch($event)"
        >
        </app-search-results-tool>
      </div>
    </div>
  </mat-sidenav>

  <!-- Panneau secondaire pour les composants passifs -->
  <mat-sidenav
    #secondarySidenav
    [mode]="isSmallScreen ? 'over' : 'side'"
    [autoFocus]="false"
    [opened]="hasActivePassiveContent()"
    [ngClass]="{ 'sidenav-mobile': isSmallScreen }"
    class="secondary-sidenav"
  >
    <div class="app-second-sidenav-content">
      <!-- app-legend-panel -->
      <div *ngIf="legendPanelOpened === true">
        <app-legend-panel
          [map]="map"
          [mobile]="mobile"
          (closeLegend)="closePanelOnCloseLegend($event)"
          (sidenavClosed)="($event)"
          (opened)="secondarySidenav.toggle()"
        >
        </app-legend-panel>
      </div>
    </div>
  </mat-sidenav>

  <button
    [ngClass]="sidenav.opened || secondarySidenav.opened ? 'sideresult-opened' : 'sideresult-closed'"
    #sidenavbutton
    mat-raised-button
    color="primary"
    id="sideresult-button"
    isRoundButton="false"
    isIconButton="true"
    MatDrawerMode="push"
    [matTooltip]="
      sidenav.opened || secondarySidenav.opened ? ('sideResult.close' | translate) : ('sideResult.open' | translate)
    "
    matTooltipPosition="after"
    (click)="toggleSidenav()"
  >
    <mat-icon
      class="icon"
      [svgIcon]="sidenav.opened || secondarySidenav.opened ? 'chevron-left' : 'chevron-right'"
    >
    </mat-icon>
  </button>
</div>
